module.exports = __webpack_public_path__ + "img/QQ空间logo.51023ac2.png";